import React, { Fragment, useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
	Container, Row, Col,
	Collapse, Navbar, NavbarToggler,
	NavbarBrand, Nav, NavItem,
} from 'reactstrap';
import CheckoutButton from '../Tienda/components/CheckoutButton';
import FloatCheckoutButton from '../Tienda/components/CheckoutButton/FloatCheckoutButton';
import TiendaNavItem from '../Tienda/components/TiendaNavItem';
import LoginNavItem from '../Tienda/components/LoginNavItem';
import RangoLogo from '../../assets/img/site/logoRangoComercialBlanco.svg';
import FacebookIcon from '../../assets/img/site/f_logo.png';
import InstagramIcon from '../../assets/img/site/Instagram.png';

import './Header.css';

const Header = (props) => {
	document.querySelector('html').scrollTo(0, 0);

	const [collapsed, setCollapsed] = useState(true);
	const toggleNavbar = () => setCollapsed(!collapsed);

	return (
		<Fragment>
			<div className="fixed-top">
				<div className="topHeader d-none d-md-block">
					<Container>
						<Row>
							<Col xs={12}>
								<p className="font-weight-bold text-xs-center">
									{"CASA CENTRAL | "}
									{"Anchorena 123"}
									<span className="topHeader__space">{" | "}</span>
									<a className="text-white" href="tel:02927432089">02927-432089</a>
									<span className="topHeader__space">{" | "}</span><strong>Seguinos&nbsp;</strong>{" en las Redes!"}
									<a className="topHeader__icon" target="_blank" href="https://www.facebook.com/rangocomercial">
										<img src={FacebookIcon} alt="logo facebook" title="Ir a nuestro Facebook" />
										{/* <i className="fa fa-facebook-square fa-2x" aria-hidden="true"></i> */}
									</a>
									<a className="topHeader__icon" target="_blank" href="https://www.instagram.com/rangocomercial/">
									<img src={InstagramIcon} alt="logo Instagram" title="Ir a nuestro Instagram" />
										{/* <i className="fa fa-instagram fa-2x" aria-hidden="true"></i> */}
									</a>
									<Link className="topHeader__icon" to="/contacto">
										<i className="fa fa-envelope" aria-hidden="true" title="Enviar un Mail"></i>
									</Link>
								</p>
							</Col>
						</Row>
					</Container>
				</div>
				<Navbar className="navbar-expand-xl navbar-dark bg-dark topHeaderNavBar">
					<Container>
						<NavbarBrand tag={Link} to="/" className="mr-auto"><img className="header-logo-img" src={RangoLogo} alt="Rango Comercial" /></NavbarBrand>
						<NavbarToggler onClick={toggleNavbar} className="mr-2" />
						{/* <InputSearch /> */}
						<Collapse isOpen={!collapsed} navbar onClick={() => setCollapsed(true)}>
							<Nav navbar className="ml-auto">
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/" exact={true}><i className="fa fa-home nav-link__icon" aria-hidden="true"></i><span>Inicio</span></NavLink>
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/quienessomos"><i className="fa fa-info-circle nav-link__icon" aria-hidden="true"></i><span>Quiénes Somos</span></NavLink>
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/proveedores"><i className="fa fa-truck nav-link__icon" aria-hidden="true"></i><span>Proveedores</span></NavLink>
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/profesionales"><i className="fa fa-users nav-link__icon" aria-hidden="true"></i><span>Profesionales</span></NavLink>
								</NavItem>
								<NavItem className="text-center tienda-nav-item">
									<TiendaNavItem />
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/sucursales"><i className="fa fa-map-marker nav-link__icon" aria-hidden="true"></i><span>Sucursales</span></NavLink>
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/enviatucv"><i className="fa fa-paper-plane nav-link__icon" aria-hidden="true"></i><span>Enviá tu CV</span></NavLink>
								</NavItem>
								<NavItem className="text-center">
									<NavLink className="nav-link" to="/contacto"><i className="fa fa-envelope nav-link__icon" aria-hidden="true"></i><span>Contacto</span></NavLink>
								</NavItem>
								<NavItem className="my-auto">
									<Row className="m-0">
										<Col xs={12} xl={6} className="px-1 my-auto text-left">
											<LoginNavItem
											classNamesDesktop="d-none d-xl-block"
											classNamesMobile="text-center border-top d-block d-xl-none"
											/>
										</Col>
										<Col md={6} className="px-1 my-auto text-left d-none d-xl-block">
											<CheckoutButton />
										</Col>
									</Row>
								</NavItem>
							</Nav>
						</Collapse>
						<div className="d-block d-xl-none">
							<FloatCheckoutButton />
						</div>
					</Container>
				</Navbar>
			</div>
		</Fragment>
	);
}

export default Header;
